import RouteStatsComponent from './route_stats.component'

let routeStatsModule = angular.module('routeStats', [])

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/routeStats');

        $stateProvider
            .state('routeStats', {
                url: '/route-stats',
                component: 'routeStats',
                data: {
                    requireLogin: true,
                    requireACL: 'route_stats.all'
                },
                parent: 'app',
            })

    })
    .component('routeStats', RouteStatsComponent)

    .name;

export default routeStatsModule;


// WEBPACK FOOTER //
// ./client/app/components/route_stats/index.js